import { render } from "./TimerComponent.vue?vue&type=template&id=45d95154"
import script from "./TimerComponent.vue?vue&type=script&lang=js"
export * from "./TimerComponent.vue?vue&type=script&lang=js"

import "./TimerComponent.vue?vue&type=style&index=0&id=45d95154&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__